import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import routesName from "@/utils/constants/routesName";

interface IMenuItems {
  title: string;
  routeName: string;
}
interface ISocialsItems {
  name: string;
  url: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props, { expose }) {
  expose();

const menuItems = computed<IMenuItems[]>(() => [
  { title: "Terms & Conditions", routeName: routesName.termsAndCondition },
  { title: "Privacy Policy", routeName: routesName.privacyPolicy },
  { title: "Refund Policy", routeName: routesName.refundPolicy },
]);
const socialsItems = computed<ISocialsItems[]>(() => [
  { name: "facebook", url: "https://facebook.com" },
  { name: "twitter", url: "https://twitter.com" },
  { name: "youtube", url: "https://youtube.com" },
]);

const __returned__ = { menuItems, socialsItems, computed, routesName }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})